<template>
  <div>
    <div class="vactivitycontent w50" :class="{'pc': !isPhone}">
      <pcheader v-show="!isPhone"></pcheader>
      <div class="topbox" v-show="isPhone">
        <img class="banner" ref="banner" src="@/assets/images/vactivitybanner.jpg" alt="">
        <div class="title">
          <img src="@/assets/images/icon-vatitle.png" alt="">
          <!--<p class="myactivity" @click="myvolunteer">我的活动</p>-->
        </div>
      </div>
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="个人信息" name="first">
        </el-tab-pane>
        <el-tab-pane label="服务信息" name="second">
        </el-tab-pane>
      </el-tabs>
      <div class="bscroll" v-show="topheight" :style="{top: topheight + 'px'}" ref="bscroll">
        <div class="bscroll-container">
          <div v-show="isshow" class="personinfo">
            <el-form ref="volunteer" :model="dataFormperson" :rules="dataFormpersonrules" label-position="top" style="width: 100%;">
              <div class="additem">
                <ul class="personul">
                  <li>
                    <div class="lileft"><i class="icon-name"></i><span>姓名</span></div>
                    <el-form-item class="" prop="realName">
                      <el-input v-model="dataFormperson.realName" placeholder="请输入" @blur.prevent="blurFun()"/>
                    </el-form-item>
                  </li>
                  <li>
                    <div class="lileft"><i class="icon-place"></i><span>身份证</span></div>
                    <el-form-item class="" prop="identityCard">
                      <el-input v-model="dataFormperson.identityCard" placeholder="请输入" @blur.prevent="blurFun()"/>
                    </el-form-item>
                  </li>
                  <li>
                    <div class="lileft"><i class="icon-sex"></i><span>性别</span></div>
                    <el-form-item class="" prop="sex">
                      <el-select v-model="dataFormperson.sex" placeholder="男">
                        <el-option value="男"></el-option>
                        <el-option value="女"></el-option>
                      </el-select>
                    </el-form-item>
                  </li>
                  <li>
                    <div class="lileft"><i class="icon-email"></i><span>邮箱</span></div>
                    <el-form-item class="" prop="email">
                      <el-input v-model="dataFormperson.email" placeholder="请输入" @blur.prevent="blurFun()"/>
                    </el-form-item>
                  </li>
                  <li>
                    <div class="lileft"><i class="icon-school"></i><span>学校/单位</span></div>
                    <el-form-item class="" prop="school">
                      <el-input v-model="dataFormperson.school" placeholder="请输入" @blur.prevent="blurFun()"/>
                    </el-form-item>
                  </li>
                  <li>
                    <div class="lileft"><i class="icon-major"></i><span>专业</span></div>
                    <el-form-item class="" prop="major">
                      <el-input v-model="dataFormperson.major" placeholder="请输入" @blur.prevent="blurFun()"/>
                    </el-form-item>
                  </li>
                  <li>
                    <div class="lileft"><i class="icon-place"></i><span>籍贯</span></div>
                    <el-form-item class="" prop="place">
                      <el-input v-model="dataFormperson.place" placeholder="请输入" @blur.prevent="blurFun()"/>
                    </el-form-item>
                  </li>
                </ul>
              </div>
              <div class="additem">
                <h2 class="pubtitle">志愿者经历</h2>
                <el-form-item prop="experience">
                  <el-input v-model="dataFormperson.experience" type="textarea" placeholder="请输入" @blur.prevent="blurFun()"/>
                </el-form-item>
              </div>
              <div class="additem">
                <h2 class="pubtitle">个人技能</h2>
                <el-form-item prop="skill">
                  <el-input v-model="dataFormperson.skill" type="textarea" placeholder="请输入" @blur.prevent="blurFun()"/>
                </el-form-item>
              </div>
            </el-form>
          </div>
          <div v-show="!isshow" class="museuminfo">
            <div class="serviceList" v-show="!popshow">
              <el-collapse v-model="activeNames">
                <el-collapse-item :title="item.museumName" :name="index" v-for="(item, index) in servicelist" :key="index">
                  <ul>
                    <li><label>上午服务时间： </label><span>{{item.amServiceTime}}</span></li>
                    <li><label>下午服务时间： </label><span>{{item.pmServiceTime}}</span></li>
                    <li><label>服务岗位： </label><span>{{item.position}}</span></li>
                    <li><label>审核状态： </label><span>{{item.status}}</span></li>
                  </ul>
                  <h4><i @click="editmuseuminfo(item)">修改</i></h4>
                </el-collapse-item>
              </el-collapse>
            </div>
            <div class="pop" v-show="popshow">
              <el-form ref="volunteer" :model="dataFormmuseum" :rules="dataFormmuseumrules" label-position="top" style="width: 100%;">
                <div class="additem">
                  <h2 class="pubtitle">志愿者服务时间</h2>
                  <div class="item personul">
                    <h2>9:00～12:00</h2>
                    <el-form-item prop="amServiceTime">
                      <el-checkbox-group v-model="dataFormmuseum.amServiceTime">
                        <el-checkbox label="星期一" name="type">星期一</el-checkbox>
                        <el-checkbox label="星期二" name="type">星期二</el-checkbox>
                        <el-checkbox label="星期三" name="type">星期三</el-checkbox>
                        <el-checkbox label="星期四" name="type">星期四</el-checkbox>
                        <el-checkbox label="星期五" name="type">星期五</el-checkbox>
                        <el-checkbox label="星期六" name="type">星期六</el-checkbox>
                        <el-checkbox label="星期日" name="type">星期日</el-checkbox>
                      </el-checkbox-group>
                    </el-form-item>
                    <h2>14:00～16:30</h2>
                    <el-form-item prop="pmServiceTime">
                      <el-checkbox-group v-model="dataFormmuseum.pmServiceTime">
                        <el-checkbox label="星期一" name="type">星期一</el-checkbox>
                        <el-checkbox label="星期二" name="type">星期二</el-checkbox>
                        <el-checkbox label="星期三" name="type">星期三</el-checkbox>
                        <el-checkbox label="星期四" name="type">星期四</el-checkbox>
                        <el-checkbox label="星期五" name="type">星期五</el-checkbox>
                        <el-checkbox label="星期六" name="type">星期六</el-checkbox>
                        <el-checkbox label="星期日" name="type">星期日</el-checkbox>
                      </el-checkbox-group>
                    </el-form-item>
                  </div>
                </div>
                <div class="additem">
                  <h2 class="pubtitle">自愿服务岗位</h2>
                  <div class="volunteerposition personul">
                    <el-form-item prop="position">
                      <el-radio-group v-model="dataFormmuseum.position">
                        <el-radio label="讲解类" name="type">讲解类</el-radio>
                        <el-radio label="非讲解类" name="type">非讲解类</el-radio>
                      </el-radio-group>
                    </el-form-item>
                  </div>
                </div>
                <div class="pubbutton" @click.stop="confirmbtn()" :class="{disabled: isdisabled}"><span>提交</span></div>
              </el-form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
import BScroll from 'better-scroll'
import Pcheader from '@/views/common/pcheader'
export default {
  name: 'volunteeractivity',
  components: {
    Pcheader
  },
  data () {
    return {
      topHeight: '',
      topheight: '',
      activeName: 'first',
      codeList: [],
      isshow: true,
      dataFormperson: {
        realName: '',
        sex: '',
        email: '',
        school: '',
        major: '',
        place: '',
        experience: '',
        skill: '',
        identityCard: ''
      },
      dataFormpersonrules: {
        realName: [{required: true, message: '姓名不能为空', trigger: 'blur'}, {min: 1, max: 100, message: '长度不能超过100个字符', trigger: 'blur'}],
        sex: [{required: true, message: '请选择性别', trigger: 'blur'}],
        email: [{required: true, message: '邮箱不能为空', trigger: 'blur'}, { type: 'email', message: '请输入正确的邮箱地址', trigger: 'blur' }],
        school: [{required: true, message: '学校/单位不能为空', trigger: 'blur'}],
        major: [{required: true, message: '专业不能为空', trigger: 'blur'}],
        place: [{required: true, message: '籍贯不能为空', trigger: 'blur'}],
        phoneNumber: [{required: true, message: '请输入手机号', trigger: 'blur'}, {pattern: /^1[3|4|5|7|8][0-9]\d{8}$/, message: '手机号格式不对', trigger: 'blur'}],
        experience: [{required: true, message: '志愿者经历不能为空', trigger: 'blur'}],
        skill: [{required: true, message: '个人技能不能为空', trigger: 'blur'}],
        identityCard: [{required: true, message: '请输入身份证号', trigger: 'blur'}, {pattern: /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/,
          message: '身份证号格式不对',
          trigger: 'blur'}]
      },
      dataFormmuseum: {
        amServiceTime: [],
        pmServiceTime: [],
        position: ''
      },
      dataFormmuseumrules: {
        amServiceTime: [{type: 'array', required: true, message: '请至少选择一段服务时间', trigger: 'change'}],
        pmServiceTime: [{type: 'array', required: true, message: '请至少选择一段服务时间', trigger: 'change'}],
        position: [{required: true, message: '请选择自愿服务岗位', trigger: 'change'}]
      },
      isdisabled: false,
      persondetail: {},
      servicelist: [],
      popshow: false,
      activeNames: ['0'],
      isPhone: false, // 是否是PC端/移动端
      screenWidth: 0 // 屏幕分辨率
    }
  },
  created () {
  },
  watch: {
    // 监听首页banner的高度
    topHeight (val) {
      if (val) {
        this.topheight = parseInt(val)
      }
    },
    // 获取全部场馆信息
    codeList (val) {
      this.getServiceinfo(val)
    }
  },
  mounted () {
    this.getrootdepartmentcode()
    this.getinfo()
    let _this = this
    this.screenWidth = document.body.clientWidth
    if (this.screenWidth < 768) {
      this.isPhone = true
      this.$refs.banner.onload = function () {
        _this.topHeight = this.height
      }
      this.scrollFn()
    } else {
      this.isPhone = false
      this.topHeight = '160'
    }
    window.onresize = () => {
      _this.screenResize()
    }
  },
  methods: {
    screenResize () {
      if (document.body.clientWidth < 768) {
        this.isPhone = true
      } else {
        this.isPhone = false
      }
    },
    // 获取地址栏参数
    getQueryStringRegExp (name) {
      var reg = new RegExp('(^|\\?|&)' + name + '=([^&]*)(\\s|&|$)', 'i')
      if (reg.test(location.href)) {
        return unescape(RegExp.$2.replace(/\+/g, ' '))
      } else {
        return ''
      }
    },
    getImage (val) {
      let imgArr = val.split(';')
      return window.SITE_CONFIG.baseUrl + '/api/volunteer/web/images/' + imgArr[0]
    },
    // 获取全部场馆名称和编码
    getrootdepartmentcode () {
      this.$http({
        url: this.$http.adornUrl(`/api/admin/front/group/name?museumCode=${this.$route.query.museumCode}`),
        method: 'get'
      }).then((res) => {
        console.log(res.data)
        if (res.data.rel === true) {
          this.codeList.push({
            key: this.$route.query.museumCode,
            value: res.data.data
          })
        }
      })
      // this.$http({
      //   url: this.$http.adornUrl(`/api/admin/front/group/root-department-code`),
      //   method: 'get'
      // }).then((res) => {
      //   if (res.data.rel === true) {
      //     let obj = res.data.data
      //     for (let i in obj) {
      //       let newobj = {}
      //       newobj.key = i
      //       newobj.value = obj[i]
      //       this.codeList.push(newobj)
      //     }
      //   }
      // })
    },
    // 获取个人信息
    getinfo () {
      this.$http({
        url: this.$http.adornUrl(`/api/volunteer/web/volunteer/info?museumCode=${this.$route.query.museumCode}`),
        method: 'get'
      }).then((res) => {
        if (res) {
          if (res.data.rel === true) {
            this.persondetail = res.data.data
            this.dataFormperson.realName = this.persondetail.realName
            this.dataFormperson.identityCard = this.persondetail.identityCard
            this.dataFormperson.sex = this.persondetail.sex
            this.dataFormperson.email = this.persondetail.email
            this.dataFormperson.school = this.persondetail.school
            this.dataFormperson.major = this.persondetail.major
            this.dataFormperson.place = this.persondetail.place
            this.dataFormperson.experience = this.persondetail.experience
            this.dataFormperson.skill = this.persondetail.skill
          } else {
            if (res.data.data === '暂无志愿者信息。') {
              this.$message({
                message: res.data.data,
                type: 'warning'
              })
              setTimeout(() => {
                this.$router.push({
                  path: `/volunteerinfo`,
                  query: {museumCode: this.$cookie.get('museumCode')}
                })
              }, 3000)
            } else {
              this.$message.error(res.data.message)
            }
          }
        } else {
          this.$message.error(res.data.message)
        }
      })
    },
    // 获取场馆服务信息
    getServiceinfo (val) {
      this.$http({
        url: this.$http.adornUrl(`/api/volunteer/web/volunteer/service-info?museumCode=${this.$route.query.museumCode}`),
        method: 'get'
      }).then((res) => {
        if (res) {
          if (res.data.rel === true) {
            if (res.data.data === undefined) {
              this.$message({
                message: '请先注册成为该馆的志愿者',
                type: 'warning'
              })
              setTimeout(() => {
                this.$router.push({
                  path: `/volunteermuseum`,
                  query: {museumCode: this.$cookie.get('museumCode')}
                })
              }, 3000)
            } else {
              let data = res.data.data
              data.museumName = val[0].value
              data.amServiceTime = data.amServiceTime.split('|').join('、')
              data.pmServiceTime = data.pmServiceTime.split('|').join('、')
              this.servicelist = [data]
              // for (var i = 0; i < data.length; i++) {
              //   data[i].amServiceTime = data[i].amServiceTime.split('|').join('、')
              //   data[i].pmServiceTime = data[i].pmServiceTime.split('|').join('、')
              //   for (var j = 0; j < val.length; j++) {
              //     if (val[j].key === data[i].museumCode) {
              //       data[i].museumName = val[j].value
              //       this.servicelist.push(data[i])
              //     }
              //   }
              // }
            }
          } else {
            if (res.data.data === '你没有志愿者信息。') {
              this.$message({
                message: res.data.data,
                type: 'warning'
              })
              setTimeout(() => {
                this.$router.push({
                  path: `/volunteerinfo`,
                  query: {museumCode: this.$cookie.get('museumCode')}
                })
              }, 3000)
            } else {
              this.$message.error(res.data.message)
            }
          }
        } else {
          this.$message.error(res.data.message)
        }
      })
    },
    // 获取指定状态的列表
    handleClick (tab) {
      if (tab.index === '0') {
        this.isshow = true
      } else if (tab.index === '1') {
        this.isshow = false
      }
    },
    // 上拉加载
    scrollFn () {
      this.$nextTick(() => {
        if (!this.scroll) {
          this.scroll = new BScroll(this.$refs.bscroll, {
            click: true,
            scrollY: true,
            probeType: 3
          })
        }
      })
    },
    // 修改服务信息
    editmuseuminfo (val) {
      this.popshow = true
      this.$refs['volunteer'].resetFields()
      this.dataFormmuseum.id = val.id
      this.dataFormmuseum.volunteerId = val.volunteerId
      this.dataFormmuseum.museumCode = val.museumCode
    },
    // 修改服务信息
    confirmbtn () {
      this.isdisabled = true
      setTimeout(() => {
        this.isdisabled = false
      }, 2000)
      this.$refs['volunteer'].validate(valid => {
        if (valid) {
          let dataForms = Object.assign({}, this.dataFormmuseum)
          dataForms.amServiceTime = dataForms.amServiceTime.join('|')
          dataForms.pmServiceTime = dataForms.pmServiceTime.join('|')
          // console.log(this.dataFormmuseum)
          // console.log(dataForms)
          this.$http({
            url: this.$http.adornUrl(`/api/volunteer/web/volunteer/museum`),
            method: 'put',
            data: dataForms
          }).then((res) => {
            if (res) {
              if (res.data.rel === true) {
                this.$message({message: res.data.data, type: 'success'})
                this.getrootdepartmentcode()
                setTimeout(() => {
                  this.popshow = false
                }, 2000)
              } else {
                this.$message.error(res.data.data)
              }
            } else {
              this.$message.error(res.data.data)
            }
          })
        }
      })
    }
  }
}
</script>

<style lang="scss">
  .fl{
    float: left;
  }
  .fr{
    float: right;
  }
  .vactivitycontent{
    -webkit-overflow-scrolling:touch;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 0;
    background: #fff;
    overflow: hidden;
    overflow-y: auto;
    .topbox{
      border-bottom-left-radius: 8px;
      border-bottom-right-radius: 8px;
      position: relative;
      overflow: hidden;
      z-index: 4;
      .banner{
        width: 100%;
        vertical-align: top;
      }
      .title{
        text-align: center;
        position: absolute;
        width:60%;
        top: 22%;
        left: 50%;
        margin: 0 0 0 -30%;
        z-index: 2;
        img{
          width: 100%;
          vertical-align: top;
        }
        .myactivity{
          display: inline-block;
          font-size: 14px;
          margin: 10px 0 0;
          padding: 0 15px;
          text-align: center;
          color: #901212;
          background: #fff;
          height: 24px;
          line-height: 24px;
          -webkit-border-radius: 24px;
          -moz-border-radius: 24px;
          border-radius: 24px;
        }
      }
    }
    .el-tabs{
      padding: 0 20px;
      margin-top: -15px;
      position: relative;
      z-index: 4;
      .el-tabs__header{
        margin-bottom: 0;
        background: #ffffff;
        -webkit-border-radius: 30px;
        -moz-border-radius: 30px;
        border-radius: 30px;
        box-shadow: 0 0 10px rgba(67,39,16,0.3);
        .el-tabs__nav-wrap::after{
          display: none;
        }
        .el-tabs__nav{
          width: 100%;
          .el-tabs__active-bar{
            display: none;
          }
          .el-tabs__item{
            width: 50%;
            padding: 0;
            text-align: center;
            height: 36px;
            line-height: 36px;
            color: #999;
            &.is-active{
              color: #a90a1a;
            }
            &#tab-second{
              position: relative;
              &::before{
                content: '';
                display: block;
                width: 1px;
                height: 18px;
                background: #ddd;
                position: absolute;
                top: 9px;
              }
              &::before{}
              left: 0;
            }
          }
        }
      }
      .el-tabs__content{
        margin: 30px 0 0;
        display: none;
      }
    }
    &.w50{
      .el-tabs{
        .el-tabs__header{
          .el-tabs__nav{
            .el-tabs__item{
              width: 50%!important;
            }
          }
        }
      }
      &.pc{
        .el-tabs{
          width: 800px;
          margin: 30px auto 30px;
          padding: 0;
          .el-tabs__header{
            box-shadow: 0 0 10px rgba(67,39,16,0.1);
          }
        }
        .bscroll{
          top: 160px;
          overflow-y: auto;
          .bscroll-container{
            width: 800px;
            margin: 0 auto;
          }
          .personinfo{
            padding: 10px 0 0;
          }
          .museuminfo{
            .pop{
              .pubbutton{
                width: 20%;
              }
            }
          }
        }
      }
    }
    .bscroll{
      position: fixed;
      right: 0px;
      left: 0px;
      bottom: 0;
      overflow: hidden;
      z-index: 1;
      padding: 0px 20px 20px;
      .personinfo,
      .museuminfo{
        padding: 40px 0 60px;
      }
      .museuminfo{
        .serviceList{
          h4{
            height: 40px;
            line-height: 40px;
            font-size: 16px;
            padding: 0 5px;
            i{
              display: inline-block;
              float: left;
              font-size: 14px;
              color: #a90a1a;
            }
          }
          ul{
            border-top: solid 1px #eee;
            padding: 10px 0 0;
            li{
              padding: 5px 5px;
              line-height: 24px;
              span{
                color: #666;
              }
            }
          }
        }
      }
      .additem{
        background: #fff;
        -webkit-border-radius: 4px;
        -moz-border-radius: 4px;
        border-radius: 4px;
        padding: 0 16px;
        margin-bottom: 10px;
        .el-form-item{
          margin-bottom: 10px;
        }
        .pubtitle{
          font-size: 16px;
          height: 46px;
          line-height: 46px;
          i{
            display: inline-block;
            float: right;
            width: 8px;
            height: 15px;
            background: url("../assets/images/icon-arrow-right.png") no-repeat;
            background-size: 100% 100%;
            position: relative;
            top: 16px;
          }
        }
        .el-textarea__inner{
          border: none!important;
          padding: 0;
          min-height: auto!important;
        }
        .personul{
          /*border-top: solid 1px #f1f1f1;*/
          padding: 20px 0px 0px;
          li{
            position: relative;
            line-height: 24px;
            margin-bottom: 20px;
            &:last-child{
              margin-bottom: 0;
            }
            i{
              display: inline-block;
              width: 18px;
              height: 18px;
              vertical-align: middle;
              margin-right: 5px;
              position: relative;
              top: -1px;
            }
            .lileft{
              position: absolute;
              top: 0;
              left: 0;
              width: 100px;
              i{
                background: url("../assets/images/icon-name.png") no-repeat;
                background-size: 100% 100%;
                &.icon-sex{
                  background: url("../assets/images/icon-sex.png") no-repeat;
                  background-size: 100% 100%;
                }
                &.icon-nickName{
                  background: url("../assets/images/icon-nickName.png") no-repeat;
                  background-size: 100% 100%;
                }
                &.icon-email{
                  background: url("../assets/images/icon-email.png") no-repeat;
                  background-size: 100% 100%;
                }
                &.icon-school{
                  background: url("../assets/images/icon-school.png") no-repeat;
                  background-size: 100% 100%;
                }
                &.icon-major{
                  background: url("../assets/images/icon-major.png") no-repeat;
                  background-size: 100% 100%;
                }
                &.icon-place{
                  background: url("../assets/images/icon-place.png") no-repeat;
                  background-size: 100% 100%;
                }
                &.icon-phoneNumber{
                  background: url("../assets/images/icon-phoneNumber.png") no-repeat;
                  background-size: 100% 100%;
                }
                &.icon-code{
                  background: url("../assets/images/icon-code.png") no-repeat;
                  background-size: 100% 100%;
                }
              }
              span{
                font-size: 16px;
                display: inline-block;
                height: 24px;
                width: 70px;
                text-align: justify;
                vertical-align: top;
                &::after {
                  display: inline-block;
                  width: 100%;
                  content: "";
                  height: 0;
                }
              }
            }
            .el-form-item{
              margin: 0 0 0 100px;
              /*border-bottom: solid 1px #f1f1f1;*/
              position: relative;
              .el-form-item__content{
                line-height: 24px;
                .el-input__inner{
                  height: 24px;
                  line-height: 24px;
                  text-align: left;
                  border: none!important;
                  font-size: 14px;
                  color: #666666;
                }
              }
              .el-select{
                width: 100%;
                .el-input__inner{
                  padding-right: 15px;
                }
                .el-input__suffix{
                  display: none;
                  right: 8px;
                  .el-input__icon{
                    line-height: 1;
                  }
                  i{
                    margin-right: 0;
                  }
                }
              }
              &.code{
                .getcode{
                  position: absolute;
                  height: 24px;
                  line-height: 26px;
                  padding: 0 15px;
                  right: 0px;
                  letter-spacing: 2px;
                  top: 0px;
                  background: #c5c5c5;
                  color: #fff;
                  -webkit-border-radius: 4px;
                  -moz-border-radius: 4px;
                  border-radius: 4px;
                  text-align: center;
                  font-size: 12px;
                  z-index: 2;
                  i{
                    margin-right: 2px;
                    line-height: 18px;
                  }
                }
                .el-input__inner{
                  padding: 0 58% 0 5px;
                  text-align: left;
                }
              }
            }
          }
        }
      }
    }
    .pop{
      .additem{
        .personul{
          padding: 0;
          h2{
            color: #a90a1a;
            font-size: 16px;
          }
        }
        .item{
          &.personul{
            padding: 0px 0px 10px;
          }
          .el-form-item{
            margin-bottom: 0px;
          }
          h2{
            color: #a90a1a;
            font-size: 16px;
            margin: 10px 0 10px;
          }
          .el-checkbox-group{
            line-height: 24px;
          }
          .el-checkbox{
            line-height: 24px;
            .el-checkbox__input.is-checked+.el-checkbox__label{
              color: #a90a1a!important;
            }
            .el-checkbox__input.is-checked .el-checkbox__inner{
              background-color: #a90a1a;
              border-color: #a90a1a;
            }
          }
        }
        .el-radio-group{
          width: 100%;
          .el-radio{
            display: inline-block;
            padding: 0 10px;
            height: 30px;
            line-height: 30px;
            text-align: center;
            border: solid 1px #fff;
            -webkit-border-radius: 4px;
            -moz-border-radius: 4px;
            border-radius: 4px;
            margin-right: 10px;
            .el-radio__inner{
              display: none;
            }
            .el-radio__label{
              padding-left: 0;
            }
            &.is-checked{
              border: solid 1px #a90a1a;
              .el-radio__label{
                color: #a90a1a;
              }
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/volunteerinfomuseumedit.vue